import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "audit" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "audit-actions" }
const _hoisted_6 = { class: "data" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Copy = _resolveComponent("Copy")
  const _component_Button = _resolveComponent("Button")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode("Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : ($options.client_id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode($setup["SettingsIcon"], { class: "icon" }),
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("b", null, "Audit API client id:", -1 /* HOISTED */)),
              _createTextVNode(" " + _toDisplayString($options.client_id), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("b", null, "Audit API client secrect:", -1 /* HOISTED */)),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "***********************", -1 /* HOISTED */)),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createVNode(_component_Copy, {
                style: {"display":"inline-block"},
                size: "1.6rem",
                onCopy: _cache[0] || (_cache[0] = $event => (_ctx.$utils.copyText($options.client_secret)))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("b", null, "OAuth endpoint:", -1 /* HOISTED */)),
              _createTextVNode(" " + _toDisplayString($setup.AUDIT_TOKEN), 1 /* TEXT */)
            ]),
            _createVNode(_component_Popconfirm, {
              width: "max-content",
              "confirm-button-text": "Yes",
              "cancel-button-text": "No",
              title: "Delete API Client?",
              disabled: $data.data_loading,
              onConfirm: $options.onDeleteClient
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    class: "action",
                    disabled: $data.data_loading
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Delete API Client")
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "onConfirm"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                disabled: $data.data_loading,
                onClick: $options.onFetchGroups
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Fetch 10 Groups")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"]),
              _createVNode(_component_Button, {
                disabled: $data.data_loading,
                onClick: $options.onFetchUsers
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Fetch 10 Users")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"]),
              _createCommentVNode("<Button :disabled=\"data_loading\" @click=\"onFetchLogs('cognito')\">10 Cognito</Button>\n        <Button :disabled=\"data_loading\" @click=\"onFetchLogs('api')\">10 API</Button>\n        <Button :disabled=\"data_loading\" @click=\"onFetchLogs('cloudtrail')\">10 Cloudtrail</Button>")
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!$data.data_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    ($data.data.length)
                      ? (_openBlock(), _createElementBlock("pre", _hoisted_7, _toDisplayString(JSON.stringify($data.data, null, 4)), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, "No audit data loaded"))
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])), [
              [_directive_loading, $data.data_loading]
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode($setup["SettingsIcon"], { class: "icon" }),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "info" }, [
              _createElementVNode("b", null, "No audit API client present")
            ], -1 /* HOISTED */)),
            _createVNode(_component_Button, {
              primary: "",
              class: "action",
              onClick: $options.onCreateClient
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Create API Client")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ], 64 /* STABLE_FRAGMENT */))
  ]))
}